export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9731.3e2b06f3.jpg";